<template>
  <el-form :label-position="'left'" label-width="95px" class="tab-file-info" v-if="dialogData.video">
    <el-form-item label="文件">{{dialogData.video.name}}</el-form-item>
    <el-form-item label="格式：">{{dialogData.video.videoType}} </el-form-item>
    <el-form-item label="ID：">{{dialogData.video.id}} </el-form-item>
    <el-form-item label="大小：">{{dialogData.video.videoSize && (dialogData.video.videoSize/1024/1024).toFixed(2)}}M</el-form-item>
    <el-divider></el-divider>
    <el-form-item label="封面图：">{{dialogData.video.videoImgPaths&&dialogData.video.videoImgPaths[0].imgPath}} </el-form-item>
    <el-form-item label="大小：">{{dialogData.video.videoImgPaths[0].size}}K</el-form-item>
    <el-divider></el-divider>
    <el-form-item label="创建用户：">{{dialogData.video.createBy}} </el-form-item>
    <el-form-item label="创建时间：">{{dialogData.video.createTime|timeFormat}}</el-form-item>
    <el-divider></el-divider>
    <el-form-item label="更新用户：">{{dialogData.video.updateBy}}</el-form-item>
    <el-form-item label="更新时间：">{{dialogData.video.updateTime|timeFormat}} </el-form-item>
    <el-divider></el-divider>
  </el-form>
</template>
<script>
export default {
  name: 'TabFileInfo',
  props: ['dialogData'],
  data () {
    return {
      videoImgPaths: this.dialogData.video.videoImgPaths ? this.dialogData.video.videoImgPaths[0] : ''
    }
  }
}
</script>
<style lang="less">
  .tab-file-info {
    .span-width {
      display: block;
      width: 150px;
    }
    padding-bottom: 30px;
    word-wrap:break-word;
  }
</style>
